import { MutationCache, QueryClient } from '@tanstack/react-query';
import { isApiError } from '@/api/errors';

/**
 * Queries retry only when the failure is transient (network, 5xx); a 4xx —
 * including ROUTE_NOT_FOUND for endpoints that have not shipped — renders
 * its state immediately.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: true,
        retry: (failureCount, error) => {
          if (isApiError(error)) return (error.isNetwork || error.status >= 500) && failureCount < 2;
          return failureCount < 1;
        },
      },
      mutations: { retry: 0 },
    },
    mutationCache: new MutationCache(),
  });
}
